import styled from 'styled-components';

export const StyledHr = styled.hr`
  margin: 1.5rem 0;
`;
